import { ServiceFetch } from '../service-fetch'

export default class ReprintModel extends ServiceFetch {
    getLastRePrintBy = (data) => this.authFetch({
        url: 're-print/getLastRePrintBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
    getRePrintBy = (data) => this.authFetch({
        url: 're-print/getRePrintBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
    updateRePrint = (data) => this.authFetch({
        url: 're-print/updateRePrint',
        method: 'POST',
        body: JSON.stringify(data),
    })

}